
import React from 'react';
import { ThemeState } from '../../types/chatbot.types';
import { Button } from '../../../ui/Button';
import { TextField } from '../../../ui/Field';

interface ThemePreviewProps {
theme: ThemeState;
chatbot:any
}

const ThemePreview: React.FC<ThemePreviewProps> = ({ theme,chatbot }) => {
  // console.log(chatbot,"CHATBOT)))))))))))")
  console.log(theme,"theme)))))))))))")

return (
<div className="border rounded-2xl p-5 bg-gray-100 h-fit">
<h3 className="text-lg font-semibold text-agentic-text-primary mb-3">Live Preview</h3>

<div
className="rounded-2xl border flex items-center justify-center"
style={{ background: theme.bg, fontFamily: theme.fontFamily }}
>
<div
className="w-[340px] h-[440px] rounded-2xl shadow-lg overflow-hidden flex flex-col"
style={{ background: theme.bg }}
>
{/* Header */}
<div
className="px-4 py-4 flex items-center justify-between"
style={{ background: theme.headerBg, color: theme.botMsgFont }}
>
<div className="flex items-center gap-2">
  {chatbot?.imgLink ? (
    <img
      src={chatbot.imgLink}
      alt={chatbot.name}
      className="h-6 w-6 rounded-full object-cover"
      onError={(e) => {
        // fallback if URL expires (S3 signed URL)
        e.currentTarget.src = '/default-bot.webp'; 
      }}
    />
  ) : (
    <span className="inline-flex h-6 w-6 rounded-full bg-gray-300" />
  )}

  <span className="text-xs font-semibold" style={{color:theme.headerTextFont}}>{chatbot?.name}</span>
</div>

{/* <div className="flex items-center gap-1">
<span className="h-2 w-2 rounded-full bg-white/40" />
<span className="h-2 w-2 rounded-full bg-white/40" />
<span className="h-2 w-2 rounded-full bg-white/40" />
</div> */}
</div>

{/* Messages area */}
<div className="flex-1 px-3 py-3 space-y-2 overflow-y-auto">
{/* Bot message */}
<div className="flex">
<div
className="inline-block max-w-[80%] rounded-2xl px-3 py-2 text-xs shadow"
style={{ color: theme.botMsgFont, background: theme.botMsgBg }}
>
{theme.welcome}
</div>
</div>

{/* User message */}
<div className="flex justify-end">
<div
className="inline-block max-w-[80%] rounded-2xl px-3 py-2 text-xs shadow"
style={{ color: theme.userMsgFont, background: theme.userMsgBg }}
>
This is how your user message looks.
</div>
</div>
</div>

{/* Input area */}
<div
className="px-3 py-2 border-t"
style={{ borderColor: theme.inputBorder || 'transparent' }}
>
<div
className="flex items-center gap-2 rounded-2xl px-3 py-1.5"
style={{ background: theme.inputTextBg }}
>
<TextField tone="transparent"
readOnly className="flex-1 outline-none text-xs"
style={{ color: theme.inputTextFont }}
value={theme.placeholder}
/>
<Button tone="custom"
type="button"
className="h-6 w-6 rounded-[6px] flex items-center justify-center shadow-sm"
style={{ background: theme.sendBtn }}
>
{/* <span className="block h-3 w-3 border-[2px] border-white border-t-transparent border-l-transparent rounded-sm rotate-45 translate-x-[1px]" /> */}
</Button>
</div>
</div>
</div>
</div>
</div>
);
};

export default ThemePreview;